"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializedElectricalSchematicViewSchema = void 0;
const zod_1 = require("zod");
exports.SerializedElectricalSchematicViewSchema = zod_1.default.object({
    id: zod_1.default.string(),
    nets: zod_1.default.record(zod_1.default.string(), zod_1.default.array(zod_1.default.object({
        moduleRef: zod_1.default.string(),
        moduleName: zod_1.default.string(),
        pinRef: zod_1.default.string(),
    }))),
});
//# sourceMappingURL=SerializedElectricalSchematicView.js.map